enum FORM_NAMES {
  junior = 'junior',
  middle = 'middle',
  senior = 'senior',
  others = 'others',
  numberOfGuests = 'number_of_guests',
  numberOfPets = 'number_of_pets',
  group_type = 'group_type',
  guests = 'guests',
}

export {FORM_NAMES};
